var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M1.25 3.75a2.5 2.5 0 0 1 2.5-2.5h1.143c.717 0 1.342.488 1.516 1.184L7.33 6.12a1.56 1.56 0 0 1-.578 1.628l-1.078.809c-.112.084-.136.207-.105.293a9.4 9.4 0 0 0 5.581 5.58c.086.032.209.008.293-.104l.809-1.078a1.56 1.56 0 0 1 1.628-.578l3.687.921a1.56 1.56 0 0 1 1.183 1.516v1.143a2.5 2.5 0 0 1-2.5 2.5h-1.875C7.126 18.75 1.25 12.874 1.25 5.625z",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;